import React, { useState, useEffect } from 'react';
import { masterData } from '../../../api/master-data';
import { attributeDetails, attributeUpdate } from '../../../api/attribute';
import Footer from '../../Layout/Footer';
import Header from '../../Layout/Header';
import Sidebar from '../../Layout/Sidebar';
// import { s3bucket } from '../../../Common/Constant';
// import { uploadImageAPI } from '../../../services/api.services';
import { useNavigate, useLocation } from "react-router-dom";

function AttributeEdit() {
    useEffect(() => {
        document.title = "Edit Attribute - Clarion Audio";
    },);

    const navigate = useNavigate();
    const location = useLocation();
    const queryString = new URLSearchParams(location.search)
    const id = queryString.get('id');
    const [form, setForm] = useState();
    const [errors, setErrors] = useState({});
    const [parentAttribute, setParentAttribute] = useState();
    const getParentAttribute = async() => {
        let res = await masterData({typeSlug: 'attribute-set'});
        if(res.status === 1){
            setParentAttribute(res.payload);
        }
    }
    useEffect(() => {
        getParentAttribute();
    },[]);

    const setField = (field, value) => {
        setForm({
            ...form,
            [field]: value
        });
        if (!!errors[field]){
            setErrors({
                ...errors,
                [field]: null
            });            
        }
    }

    const getAttributeDetail = async () => {
        let res = await attributeDetails({payload:id})
        if(res.status === 1){
            setForm({
                ...form,
                ['name']: res.payload.name,
                ['parentID']: res.payload.parentID,
                ['priority']: res.payload.priority,
                ['status']: res.payload.status,
                ['imageURL']: res.payload.imageURL
            });
        }
    }
    useEffect(() => {
        getAttributeDetail();
    },[]);

    const validateForm = () =>{
        const {parentID, name} = form;
        const newErrors = {};
        if(!name || name === '') newErrors.name = 'Please enter this field';
        if(!parentID || parentID === 'Select attribute set') newErrors.parentID = 'Please select this field';
        return newErrors;
    }
    const handleUpdate = async (e) => {
        e.preventDefault();
        setErrors();
        const formErrors = validateForm();
        if(Object.keys(formErrors).length > 0){
            setErrors(formErrors)
        } else {
            let res = await attributeUpdate({payload:{
                id: id,
                name: form.name,
                parentID: form.parentID,
                imageURL: null,//form.imageURL && form.imageURL !== '' ? form.imageURL : null,
                priority: form.priority && form.priority !== '' ? form.priority : 0,
                status: form.status
            }});
            if(res.status === 1){
                navigate("/attribute/list");
            }//  else {
            //     setErrors({...errors,['update']:res.message})
            // }
        }
        
    }

    const handleCancel = () => {
        navigate("/attribute/list");
    }

    // const handleChange = (e) => {
    //     checkFile(e.target.files);
    // };
    // const checkFile = async (file) => {
    //     if(file.length === 0) return;

    //     // let fileElement = file[0];
    //     // let fileExtension = "";
    //     // if (fileElement.name.lastIndexOf(".") > 0) {
    //     //     fileExtension = fileElement.name.substring(fileElement.name.lastIndexOf(".") + 1, fileElement.name.length);
    //     // }
    //     let res = await uploadImageAPI('/upload/common/', file)
    //     if (res.status === 1) {
    //         setForm({
    //             ...form,
    //             ['imageURL']: res.url
    //         });
    //         if (!!errors['imageURL']) {
    //             setErrors({
    //                 ...errors,
    //                 ['imageURL']: null
    //             });
    //         }

    //         document.getElementById("attributeFileUrl").value = res.url;
    //         document.getElementById('imageView').style.display = 'inline-block';
    //         document.getElementById('imageView').src = s3bucket+res.url;
    //     } else {
    //         setErrors({...errors,['imageURL']:res.message});
    //     }
    // }

    return (
        <div>
            <Sidebar />
            <Header />
            <div id="layout-wrapper">
                <div className="main-content">
                    <div className="page-content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">
                                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                        <h4 className="mb-sm-0">Edit Attribute</h4>
                                        <div className="page-title-right">
                                            <ol className="breadcrumb m-0">
                                                <li className="breadcrumb-item"><a >Home</a></li>
                                                <li className="breadcrumb-item">Attribute</li>
                                                <li className="breadcrumb-item active">Edit Attribute</li>
                                            </ol>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            {/* <!-- end page title --> */}
                            <div className="row mt-2">
                                <div className="col-xl-12 col-lg-12">
                                    <div className="card">
                                        {/* <!-- end card header --> */}
                                        <div className="card-body">
                                            <div className='row'>
                                                <form onSubmit={handleUpdate}>
                                                    {/* <div className="row">
                                                        <div className="col-md-4">
                                                            <div className="mb-3 required_field">{errors?.update}</div>
                                                        </div>
                                                    </div> */}
                                                    <div className="row">
                                                        <div className="col-md-4">
                                                            <div className="mb-3">
                                                                <label htmlFor="ForminputState" className="form-label mb-0">Parent attribute <span className="required_field">*{errors?.parentID}</span></label>
                                                                <select id="ForminputState" className="form-select" data-choices data-choices-sorting="true" onChange={(e) => setField('parentID',e.target.value)}>
                                                                    <option value={""} key={0}>Select attribute set</option>
                                                                    {parentAttribute?.map((prAttr) => {
                                                                        return (<option value={prAttr.ID} key={prAttr.ID} selected={prAttr.ID === form?.parentID ? true : false}>{prAttr.name}</option>)
                                                                    })}
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="mb-3">
                                                                <label className="form-label mb-0">Attribute Name 
                                                                    <span className="required_field">*{errors?.name}</span>
                                                                </label>
                                                                <input type="text" className="form-control" placeholder="Enter attribute name" id="name" defaultValue={form?.name} onChange={(e) => setField('name', e.target.value)} />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="mb-3">
                                                                <label className="form-label mb-0">Priority</label>
                                                                <input type="text" className="form-control" placeholder="Enter priority" id="priority" defaultValue={form?.priority} onChange={(e) => setField('priority', e.target.value)} />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="mb-3">
                                                                <label className="form-label mb-0">Status</label>
                                                                <select id="ForminputState" className="form-select" data-choices data-choices-sorting="true" onChange={(e) => setField('status',e.target.value)}>
                                                                    <option value={0} key={0} selected={0 === form?.status ? true : false}>Inactive</option>
                                                                    <option value={1} key={1} selected={1 === form?.status ? true : false}>Active</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        {/* <div className="col-md-4">
                                                            <div className="mb-3">
                                                                <label className="form-label mb-0">Image (Dimension: 200 X 200 pixels)</label>
                                                                <input type="file" className="form-control" id="attributeFile" onChange={handleChange} multiple />
                                                            </div>
                                                            <img className="mt-3" id="imageView" src={form?.imageURL ? form?.imageURL : ""} style={{display:'none',height:"50px", border:"2px solid grey"}} />
                                                        </div> */}
                                                    </div>
                                                    {/* <!--end row--> */}

                                                    <div className="row text-end d-inline">
                                                        <div className="col-md-12">
                                                            <button type="button" className="btn btn-primary mx-2" id="updateButton" onClick={handleUpdate}>Update</button>
                                                            <button type="button" className="btn btn-danger mx-2" id="cancelButton" onClick={handleCancel}>Cancel</button>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default AttributeEdit